import { Column, TableColumnExtensions } from './types';

export const All_SITE_CONNECTION_REPORT = 'All site connections';

export const ALL_SITE_CONNECTIONS_REPORT_MESSAGE =
  'A list of all connections in the system for every site. INTERNAL.';

export const ALL_SITE_CONNECTIONS_REPORT_GRID_TITLE =
  'allSitesConnectionsReport';

export const tableColumnExtensions: TableColumnExtensions[] = [
  { columnName: 'repairerGroup', wordWrapEnabled: true },
  { columnName: 'siteCode', wordWrapEnabled: true },
  { columnName: 'capsInboundConnection', wordWrapEnabled: true },
  { columnName: 'accountStatus', wordWrapEnabled: true },
  { columnName: 'subscriptionType', wordWrapEnabled: true },
  { columnName: 'name', wordWrapEnabled: true },
  { columnName: 'address', wordWrapEnabled: true },
  { columnName: 'postcode', wordWrapEnabled: true },
  { columnName: 'systemType', wordWrapEnabled: true },
  { columnName: 'audatex', wordWrapEnabled: true },
  { columnName: 'capsOutboundConnections', wordWrapEnabled: true },
  { columnName: 'allianz', wordWrapEnabled: true },
  { columnName: 'coveaCode', wordWrapEnabled: true },
  { columnName: 'dlgNetwork', wordWrapEnabled: true },
  { columnName: 'esure', wordWrapEnabled: true },
  { columnName: 'lvConnection', wordWrapEnabled: true },
  { columnName: 'nargNetwork', wordWrapEnabled: true },
  { columnName: 'nnsSiteCode', wordWrapEnabled: true },
  { columnName: 'rsa', wordWrapEnabled: true },
  { columnName: 'itasNetwork', wordWrapEnabled: true },
  { columnName: 'kindertons', wordWrapEnabled: true },
];

export const columns: Column[] = [
  { name: 'repairerGroup', title: 'Group' },
  { name: 'siteCode', title: 'Site Code' },
  { name: 'capsInboundConnection', title: 'CAPS Code' },
  { name: 'accountStatus', title: 'Account Status' },
  { name: 'subscriptionType', title: 'Subscription Type' },
  { name: 'name', title: 'Name' },
  { name: 'address', title: 'Address' },
  { name: 'postcode', title: 'Postcode' },
  { name: 'systemType', title: 'System Type' },
  { name: 'audatex', title: 'Audatex ID' },
  { name: 'capsOutboundConnections', title: 'CAPS Connections' },
  { name: 'allianz', title: 'Allianz' },
  { name: 'coveaCode', title: 'Covea' },
  { name: 'dlgNetwork', title: 'DLG' },
  { name: 'esure', title: 'Esure' },
  { name: 'lvConnection', title: 'LV' },
  { name: 'nargNetwork', title: 'NARG' },
  { name: 'nnsSiteCode', title: 'NNSSite Code' },
  { name: 'rsa', title: 'RSA' },
  { name: 'itasNetwork', title: 'ITAS' },
  { name: 'kindertons', title: 'KINDERTONS' },
];
